export const SUGGEST_URL = 'https://europe-west6-dxt-data.cloudfunctions.net/suggest_law'
export const CHAT_URL = 'https://europe-west6-dxt-data.cloudfunctions.net/chat_law'
